import { Tooltip } from '@/components/ui'
import { useOnlineUsers } from '@/hooks/useOnlineUsers'

/**
 * 헤더용 동시접속자 배지 — 초록 점 + 숫자 (로그인 시에만 표시).
 * prefers-reduced-motion에서는 전역 CSS가 pulse를 비활성화한다.
 */
export function OnlineUsersBadge() {
  const count = useOnlineUsers()
  if (count === null || count < 1) return null

  return (
    <Tooltip content={`현재 접속자 ${count}명`} placement="bottom">
      <div
        className="flex items-center gap-1 px-1.5 h-[22px] rounded-full bg-surface-tertiary select-none"
        role="status"
        aria-label={`현재 동시접속자 ${count}명`}
      >
        <span className="relative flex w-1.5 h-1.5" aria-hidden="true">
          <span className="animate-pulse absolute inline-flex h-full w-full rounded-full bg-success-500" />
          <span className="relative inline-flex rounded-full w-1.5 h-1.5 bg-success-500" />
        </span>
        <span className="text-meta font-medium text-caption tabular-nums">{count}</span>
      </div>
    </Tooltip>
  )
}
